/* eslint-disable import/first */
import React, { Children } from 'react';
import ClassNames from 'classnames';
import Divider from '@material-ui/core/Divider';
import { useNavigate, useLocation } from '@reach/router';
import SideMenu from '../../SideMenu';
import { useIntl } from 'react-intl';
import PizzaHutLogo from '../../../brands/phd/logo';
// eslint-disable-next-line import/no-cycle
import OrderModesBar from '../../OrderModesBar';
import AddressSelector from '../../AddressSelector';
import CartButton from '../CartButton';
import LoginButton from '../../LoginButton';
import { localizePath } from 'spwa-ui-library/esm/utils/helper';

import css from './index.module.scss';

const Section = ({ children, tagName = 'div', ...props }) => {
  const TagName = tagName;

  return (
    <React.Fragment>
      {Children.count(children) ? <TagName {...props}>{children}</TagName> : ''}
    </React.Fragment>
  );
};

const DesktopHeader = React.forwardRef((props, ref) => {
  const intl = useIntl();
  const { actionButtons = [], desktopActionButtons = null, className = '' } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const icon = <SideMenu />;
  const logo = <PizzaHutLogo />;
  const orderModes = <OrderModesBar isDesktopHeader={true} />;
  const addressSelector = <AddressSelector />;
  const cart = <CartButton isFloating={false} />;
  const login = <LoginButton />;
  const homeURL = localizePath('/home', intl.locale);

  const handleLogo = (e) => {
    e.preventDefault();
    navigate(homeURL);
  };
  // NOTE: Adding cart to the beginning of action buttons
  // actionButtons.splice(0, 0, cart);

  return (
    <header className={ClassNames(className, css.root)} ref={ref}>
      <div className={css.innerWrapper}>
        <Section className={css.iconSection}>{icon}</Section>
        <Section className={css.logoSection} href={homeURL} onClick={handleLogo} tagName="a">
          {logo}
        </Section>
        <Section className={css.orderModesSection}>{orderModes}</Section>
        <Section className={css.dividerSection}>
          <Divider orientation="vertical" />
        </Section>
        <Section className={css.addressSelectorSection}>{addressSelector}</Section>
        <Section className={css.actionButtonSection}>
          {React.cloneElement(cart, {
            key: `actionButton-${cart.type.name}`,
            className: ClassNames(cart.props.className, css.actionButton),
          })}
          {(desktopActionButtons || actionButtons).map(
            (actionButton, idx) =>
              actionButton &&
              React.cloneElement(actionButton, {
                key: `actionButton-${actionButton.type.name}`,
                className: ClassNames(actionButton.props.className, css.actionButton),
              })
          )}
          {React.cloneElement(login, {
            key: `actionButton-${login.type.name}`,
            className: ClassNames(login.props.className, css.actionButton),
          })}
        </Section>
      </div>
    </header>
  );
});

export default DesktopHeader;
